import config from '../config/environments';

/**
 * Build the absolute, **public** logo URL for a venue.
 *
 * Used by every <img> that displays a venue logo (admin venues list,
 * admin venue dashboard, public customer wine list). The /api/admin/.../logo/file
 * endpoint requires a Bearer token that <img> requests can't attach, so all
 * <img> tags resolve through this helper to the public binary route.
 *
 * `cacheBust` (e.g. `logoUploadedAt`) busts the browser cache when a logo
 * gets replaced server-side without changing the URL path. Pass undefined to
 * skip cache-busting.
 */
export const buildPublicVenueLogoUrl = (
  venueId: string,
  cacheBust?: string | number | null,
): string => {
  const v = cacheBust != null ? `?v=${encodeURIComponent(String(cacheBust))}` : '';
  return `${config.apiUrl}/public/venue/${encodeURIComponent(venueId)}/logo/file${v}`;
};

/**
 * Initials fallback for venues without a logo. "Maison du Vin" → "MV";
 * single-word names → first two letters; empty → "?".
 */
export const venueInitials = (name: string | undefined | null): string => {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};
